
<h1 mat-dialog-title>{{ 'ABOUT_EMPLOYEE_ADD_DIALOG.TITLE' | translate }}</h1>
<div mat-dialog-content>

    <div>
        {{ 'ABOUT_EMPLOYEE_ADD_DIALOG.EMPLOYEE' | translate }}: {{ data.aboutEmployeeName }}
    </div>

    <div class="about-employee-options">
        <mat-checkbox class="multiline" [(ngModel)]="isAuraLeader">{{ 'ABOUT_EMPLOYEE_ADD_DIALOG.AURA_360_LEADER' | translate }}</mat-checkbox>
    </div>

</div>
<div mat-dialog-actions class="flex-h flex-end">
    <button mat-flat-button color="primary" (click)="ok()" type="submit">{{ 'GENERAL.OK' | translate }}</button>
    <button mat-flat-button color="accent" [mat-dialog-close]>{{ 'GENERAL.CANCEL' | translate }}</button>
</div>
